var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from 'react';
import { fetchAvailableMovements, fetchCampaignsByMovement, fetchUpdatesByMovement } from '../utils/cdnFetcher';
export var useGetMovement = function (initialMovement) {
    var _a = useState([]), availableMovements = _a[0], setAvailableMovements = _a[1];
    var _b = useState(null), selectedMovement = _b[0], setSelectedMovement = _b[1];
    var _c = useState(new Map()), movementCache = _c[0], setMovementCache = _c[1];
    var getMovementData = function (movement) { return __awaiter(void 0, void 0, void 0, function () {
        var allCampaigns, allUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchCampaignsByMovement(movement)];
                case 1:
                    allCampaigns = _a.sent();
                    return [4 /*yield*/, fetchUpdatesByMovement(movement)];
                case 2:
                    allUpdates = _a.sent();
                    return [2 /*return*/, {
                            campaigns: allCampaigns,
                            movementSlug: movement.slug,
                            updates: allUpdates,
                        }];
            }
        });
    }); };
    var getAndSetDataForMovement = function (movement) { return __awaiter(void 0, void 0, void 0, function () {
        var allCampaigns, allUpdates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchCampaignsByMovement(movement)];
                case 1:
                    allCampaigns = _a.sent();
                    return [4 /*yield*/, fetchUpdatesByMovement(movement)];
                case 2:
                    allUpdates = _a.sent();
                    setMovementCache(function (prev) {
                        var newCache = new Map(prev);
                        newCache.set(movement.slug, {
                            campaigns: allCampaigns,
                            movementSlug: movement.slug,
                            updates: allUpdates,
                        });
                        return newCache;
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var getMovementDataForRemainingMovements = function (movements) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(movements.map(function (movement) { return getAndSetDataForMovement(movement); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Wrap setSelectedMovement in useCallback to ensure it's stable
    var updateSelectedMovement = useCallback(function (movement) {
        setSelectedMovement(movement);
    }, []);
    useEffect(function () {
        var fetchMovements = function () { return __awaiter(void 0, void 0, void 0, function () {
            var movements, selectedIndex, movementIndex, selected, selectedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAvailableMovements()];
                    case 1:
                        movements = _a.sent();
                        setAvailableMovements(movements);
                        selectedIndex = 0;
                        if (initialMovement) {
                            movementIndex = movements.findIndex(function (movement) { return movement.slug === initialMovement; });
                            selectedIndex = movementIndex >= 0 ? movementIndex : 0;
                        }
                        selected = movements[selectedIndex];
                        updateSelectedMovement(selected);
                        return [4 /*yield*/, getMovementData(selected)];
                    case 2:
                        selectedData = _a.sent();
                        setMovementCache(function (prev) {
                            var newCache = new Map(prev);
                            newCache.set(selected.slug, selectedData);
                            return newCache;
                        });
                        // Preload the rest
                        getMovementDataForRemainingMovements(movements.filter(function (m, i) { return i !== selectedIndex; }));
                        return [2 /*return*/];
                }
            });
        }); };
        fetchMovements();
    }, [initialMovement, updateSelectedMovement]);
    return { availableMovements: availableMovements, movementCache: movementCache, selectedMovement: selectedMovement, setSelectedMovement: updateSelectedMovement };
};
